import React from "react";
import './DataResults.css';
import Data from "../img/data.png";
import GAD from "../img/GoogleAds.png";
import GAnalytics from "../img/GAnalytics.svg";
import MetaImage from "../img/Meta.png";
import GTMImage from "../img/GTM.png";

const DataResults = () => {
    return (
        <section className="data-results">

            {/* Large circle on the right */}
            <div className="large-circle-right"><img src={Data} />
            </div>

            <div className="data-results-container">
                <h2 className="data-results-title">データが証明する成果</h2>
                
                <div className="stats-row">
                    <div className="stat-item">
                        <div className="stat-value stat-blue">180%</div>
                        <div className="stat-label">平均ROAS</div>
                        <div className="stat-description">広告費用対効果</div>
                    </div>
                    <div className="stat-item">
                        <div className="stat-value stat-red">+127%</div>
                        <div className="stat-label">CVR改善率</div>
                        <div className="stat-description">コンバージョン向上</div>
                    </div>
                    <div className="circle-content">
                    <div className="circle-value">50+</div>
                    <div className="circle-label">運用実績</div>
                    <div className="circle-description">継続実績数</div>
                </div>
                </div>

                <div className="technologies-section">
                    <h3 className="technologies-title">使用テクノロジー</h3>
                    <div className="technologies-row">
                        <div className="tech-item">
                            <img src={GAD} alt="Google Ads" className="tech-logo" />
                            <span className="tech-name">Google Ads</span>
                        </div>
                        <div className="tech-item">
                            <img src={GAnalytics} alt="Google Analytics 4" className="tech-logo" />
                            <span className="tech-name">Google Analytics 4</span>
                        </div>
                        <div className="tech-item">
                            <img src={MetaImage} alt="Meta Business" className="tech-logo" />
                            <span className="tech-name">Meta Business</span>
                        </div>
                        <div className="tech-item">
                            <img src={GTMImage} alt="Data Studio" className="tech-logo" />
                            <span className="tech-name">GoogleTagManager</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DataResults;